import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";
import { AssetTypeDto } from "src/store/asset-types/type";
import { createDeliveryRefundDefinition } from "src/store/contract-pickup-definition/saga";
import { getDataTypes } from "src/store/system/saga";
import { DataTypeDto } from "src/store/system/type";
import * as Yup from "yup";

const ContractDeliveryRefundDefinitionCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [assettypes, setAssettypes] = useState<AssetTypeDto[]>([]);
  const [datatypes, setDatatypes] = useState<DataTypeDto[]>([]);
  useEffect(() => {
    if (open) {
      dispatch(
        getDataTypes({
          payload: {
            onSuccess: (message, payload) => {
              setDatatypes(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssettypes(payload);
            },
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t(
            "Contract.DeliveryRefundDefinition.CreateFormTitle"
          ).toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createDeliveryRefundDefinition({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
          AssetTypeId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DataTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Contract.DeliveryRefundDefinition.Name").toString(),
          },
        ]}
        inputs={[
          {
            disabled: true,
            field: "AssetTypeId",
            label: t("Contract.DamageDefinition.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assettypes,
            },
          },
          {
            disabled: true,
            field: "DataTypeId",
            label: t("Contract.DamageDefinition.DataType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: datatypes,
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ContractDeliveryRefundDefinitionCreateForm;
